var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnIfBlock = function SvgIcnIfBlock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1C6.44772 1 6 1.44772 6 2V4C6 4.55228 6.44772 5 7 5H8V8H3V9V11H2C1.44772 11 1 11.4477 1 12V14C1 14.5523 1.44772 15 2 15H5C5.55228 15 6 14.5523 6 14V12C6 11.4477 5.55228 11 5 11H4V9H13V11H12C11.4477 11 11 11.4477 11 12V14C11 14.5523 11.4477 15 12 15H15C15.5523 15 16 14.5523 16 14V12C16 11.4477 15.5523 11 15 11H14V9V8H9V5H10C10.5523 5 11 4.55228 11 4V2C11 1.44772 10.5523 1 10 1H7Z",
    fill: "#808080"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnIfBlock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_if_block.fc6c770e.svg";
export { ForwardRef as ReactComponent };